import gql from 'graphql-tag';

export const instNameGql = gql`
  query ($instId: String!) {
    institutions(instID: $instId) {
      name
      locations {
        experience_type
      }
    }
  }
`;

export const getInstAccessModules = gql`
  query ($instId: String!) {
    institutions(instID: $instId) {
      modules {
        module
        enabled
      }
    }
  }
`;

export const getInstNameAndUniversitiesGql = gql`
  query ($userId: Int!, $instId: String!) {
    user(id: $userId, requiresLeadAccess: false) {
      organizations {
        label
        type
        id
        uniqueId
        numExperiences
      }
    }
    institutions(instID: $instId) {
      name
      locations {
        experience_type
      }
    }
  }
`;

export const changeUniversityGql = gql`
  mutation ($inst_id: String!) {
    loginAs(inst_id: $inst_id, inCurrentSession: true) {
      success
    }
  }
`;
